angular
	.module 'App.Service'
	.factory 'UserRestrictionService', [() ->
		class UserRestrictionService
			constructor : () ->
				@strategies = []

			register : (command) ->
				@strategies.push(new Strategy(command))

			apply : (concrete, query) ->
				for strategy in @strategies
					query = strategy.apply(concrete, query)

				return query

		return new UserRestrictionService
	]

class Strategy
	constructor : (@command) ->
	apply : (concrete, query) ->
		return @command.apply(concrete, query)
